import React, { useRef, useState } from 'react'
import { useOnClickOutside } from 'usehooks-ts'

export const Tooltip = ({ text, children }) => {
    const [showTooltip, setShowTooltip] = useState(false)
    const ref = useRef()

    useOnClickOutside(ref, () => setShowTooltip(false))

    return (
        <div className="relative z-10">
            <div
                className="relative z-10 inline-block"
                onMouseEnter={() => setShowTooltip(true)}
                onMouseLeave={() => setShowTooltip(false)}
                ref={ref}>
                {children}
                {showTooltip && (
                    <div className="absolute top-0 transform -translate-y-full -translate-x-1/2 left-1/2 z-50">
                        <div className="bg-orange-100 text-olm-black text-sm py-2 px-2 rounded-lg shadow-lg w-56 text-center">
                            <span className="whitespace-normal">{text}</span>
                            <svg
                                className="absolute text-orange-100 h-2 w-full left-0 top-full"
                                x="0px"
                                y="0px"
                                viewBox="0 0 255 255"
                                xmlSpace="preserve">
                                <polygon
                                    className="fill-current"
                                    points="0,0 127.5,127.5 255,0"
                                />
                            </svg>
                        </div>
                    </div>
                )}
            </div>
        </div>
    )
}
